<!--
 * @Author: hfxie
 * @Date: 2022-05-07 16:39:30
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-07-09 09:50:19
 * @Description: 常规全量渲染甘特图WBS行滚动列表
-->

<template>
  <div
    ref="list"
    class="scroll-list-container nomal-list-container"
    @scroll.passive="scrollEvent($event)"
  >
    <div
      class="nomal-list"
      :class="{
        'gantt-outbox-border': (!$store.state.viewSchem.noGanttOutBoxBorder),
      }"
    >
        <!-- 增加下划线 -->
      <div
        class="nomal-list-item"
        :class="{
          'list-item-border-bottom': item.borderBottom == true,
        }"
        :data-name="item.name"
        :data-id="item.id"
        v-for="(item,index) in visibleData"
        :key="item.id"
        :style="{
          'height': ((item.rowCount? item.rowCount: 1) * estimatedItemSize  + 'px'),
          'color': item.color,
          'background': setBG(index,$store.state.viewSchem.isZebraStripes)
        }"
      >
        <slot ref="slot" :item="item"></slot>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "NomalList",
  data() {
    return {

    };
  },
  props: {
    // 所有列表数据
    listData: {
      type: Array,
      default: () => [],
    },
    positions: {
      type: Array,
      default: () => [],
    },
    // 单行高度
    estimatedItemSize: {
      type: Number,
      default: () => { return 50; },
    },
    totalHeight: {
      type: Number,
      default: () => { return 0; },
    },
    scrollTop: {
      type: Number,
      default: () => { return 0; },
    },
  },
  computed: {
    visibleData() {
      const visibleArr = this.listData;
      return visibleArr;
    },
    getHeight() {
      let ganttBgCss = "";
      if (this.totalHeight === 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.totalHeight + "px",
        };
      }
      return ganttBgCss;
    },
  },
  inject: ["CONSTNAME"],
  mounted(){
    console.log("N渲染, 距顶:", this.scrollTop);
    this.$el.scrollTop = this.scrollTop;
  },
  beforeDestroy(){    
    console.log("N销毁");
  },
  methods: {
    // 设置斑马纹
    setBG(index, isZebraStripes) {
      if (isZebraStripes) {
        if (index % 2 == 0) {
          return "#F4F4F4";
        } else {
          return "#ffffff";
        }
      }
      
    },
    // 滚动事件
    scrollEvent() {
      let scrollTop = this.$el.scrollTop;
      if(this.$store.state[this.CONSTNAME.PLANS + "_hasNext"]) {
        let clientHeight = this.$el.clientHeight;
        let scrollHeight = this.$el.scrollHeight;
        let offSetY = 100;
        let isEnd = (scrollTop + clientHeight >= scrollHeight - 1 - offSetY) && (scrollTop + clientHeight <= scrollHeight + 1);
        if(
          (scrollTop > 0 && scrollHeight > 0) &&
          isEnd && 
          !this.$store.state.dataLoadingStatus
        ) {
          this.$store.commit("set_dataLoadingStatus", true);
          console.log("N·加载更多");
          this.$store.dispatch("_loadContent", "N·加载更多");
          
        }
      }

      this.$emit("handleScroll", { scrollTop });
      scrollTop = null;
    },
  },
};
</script>


<style scoped lang='less'>
.nomal-list-container {
  overflow: auto;
  position: relative;
  -webkit-overflow-scrolling: touch;
  height: 100%;
}



.nomal-list-item {
  &.list-item-border-bottom{
    border-bottom: 1px solid @cBorderX;
    border-bottom: 1px solid var(--borderX-color, #666666);
  }
  &:last-of-type {
    border-bottom: none;
  }
}
.nomal-list{
  &.gantt-outbox-border{
    .nomal-list-item{
      .task-info-row{
        border-left: 1px solid @cBorder;
        border-left: 1px solid var(--border-color, @cBorder);
      }
    }
  }
}

</style>
